import {DiffViewSettings} from '@github-ui/diff-view-settings'
import type {CommitNotices, UserNotice} from '@github-ui/diff-view-settings/types'
import {useStickyObserver} from '@github-ui/use-sticky-header/useStickyObserver'
import {ArrowUpIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {memo} from 'react'

import type {HeaderInfo} from '../../types/commit-types'

interface DiffsHeaderProps {
  headerInfo: HeaderInfo
  treeToggleElement: React.ReactElement
  searchBox?: React.ReactElement
  ignoreWhitespace?: boolean
  userNotices?: Array<UserNotice<CommitNotices>>
}

export const DiffsHeader = memo(DiffsHeaderUnmemoized)

function DiffsHeaderUnmemoized({treeToggleElement, searchBox, ignoreWhitespace, userNotices}: DiffsHeaderProps) {
  const {isSticky: isStickied, sentinelRef: diffHeaderRef} = useStickyObserver()

  return (
    <div
      className="d-flex flex-items-center gap-2 tmp-pt-3 tmp-pt-lg-4 pb-2 position-sticky top-0 color-bg-default"
      style={{zIndex: 2}}
      ref={diffHeaderRef}
    >
      <div className="d-flex flex-items-center">{treeToggleElement}</div>

      <div className="d-flex gap-2 flex-items-center width-full">
        {isStickied && <GoToTopButton />}
        {searchBox !== undefined && searchBox}
        <DiffViewSettings reloadOnWhitespaceChange defaultHideWhitespace={ignoreWhitespace} userNotices={userNotices} />
      </div>
    </div>
  )
}

const GoToTopButton = () => {
  return (
    <Button
      leadingVisual={ArrowUpIcon}
      variant="invisible"
      className="fgColor-default px-2 f6 gap-1"
      onClick={event => {
        event.preventDefault()
        window.scrollTo({top: 0, behavior: 'smooth'})
      }}
    >
      Top
    </Button>
  )
}
